import WithModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import CourseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';

export default [WithModules, CourseWrapper];
